<template>
  <Breadcrumb :items="breadcrumbs" />
  <Loading v-if="loading" />
  <div v-else class="ds-page">
    <div class="ds-container">
      <div class="ds-page-header">
        <div>
          <h1 class="ds-page-header__title">من نحن</h1>
          <p class="ds-page-header__subtitle">محتوى صفحة "من نحن" الظاهرة على الموقع العام</p>
        </div>
        <div class="ds-page-header__actions" v-if="isAdmin">
          <router-link to="/about/edit" class="ds-btn ds-btn--primary">
            <i class="pi pi-pencil"></i> تعديل
          </router-link>
        </div>
      </div>

      <div v-if="!about || !about.content" class="empty-state empty-state--card">
        <div class="empty-state__icon"><i class="pi pi-info-circle"></i></div>
        <h3 class="empty-state__title">لا يوجد محتوى بعد</h3>
        <p class="empty-state__desc">لم يتم إضافة محتوى صفحة "من نحن" بعد.</p>
        <router-link v-if="isAdmin" to="/about/edit" class="ds-btn ds-btn--primary empty-state__action">
          <i class="pi pi-plus"></i> إضافة المحتوى
        </router-link>
      </div>

      <template v-else>
        <img v-if="about.image_link" :src="about.image_link" :alt="about.title" class="about-hero" />
        <h2 v-if="about.title" class="about-title">{{ about.title }}</h2>
        <div class="post-content" v-html="about.content"></div>
      </template>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Breadcrumb from '@/components/global/breadcrumb.vue';
import Loading from '@/components/global/loading.vue';

export default {
  name: 'AboutIndex',
  components: { Breadcrumb, Loading },
  data() {
    return {
      breadcrumbs: [{ name: 'الرئيسية', path: '/' }, { name: 'من نحن', path: '/about' }],
      about: null,
      loading: true,
    };
  },
  computed: {
    isAdmin() { return this.$store.getters.isAdmin; },
  },
  async mounted() {
    try {
      const { data } = await axios.get('/admin/about-page');
      this.about = data.data;
    } finally {
      this.loading = false;
    }
  },
};
</script>

<style scoped>
.about-hero { width: 100%; max-height: 360px; object-fit: cover; border-radius: var(--radius-lg); margin-bottom: 1.5rem; }
.about-title { font-size: 1.4rem; font-weight: 800; color: var(--text-primary); margin-bottom: 1rem; }
.post-content { line-height: 1.9; color: var(--text-primary); font-size: 1rem; }
.post-content :deep(img) { max-width: 100%; border-radius: var(--radius-md); }
</style>
